// Re-export everything from @mui/material (v5+), replacing Dialog.
export * from '@mui/material-lib';
import { Dialog as DialogBase } from '@mui/material-lib';
import { createStackedDialog } from '../components/stackedDialogWrapper';
export const Dialog = createStackedDialog(DialogBase);
